import { Component, OnInit, OnDestroy } from '@angular/core';
import { Facturedetail } from 'src/app/entity/Facture';
import { ClientService } from 'src/app/service/client.service';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FactureService } from 'src/app/service/facture.service';
import { MatTableDataSource } from '@angular/material/table';
 

@Component({
  selector: 'app-other-options',
  templateUrl: './other-options.component.html',
  styleUrls: ['./other-options.component.css']
})
export class OtherOptionsComponent implements OnInit ,OnDestroy{


factureDetails:Facturedetail[];
 routeSub:Subscription;
dataSource=new MatTableDataSource();
idClient:number
displayedColumns: string[] = ['designation', 'quantite', 'prixunit','stotal'];

  constructor(private clientService:ExhibitorService,private activatedRoute:ActivatedRoute,private router:Router,private factureService:FactureService) { 
      this.routeSub = this.activatedRoute.params.subscribe(params => {
 
 
   this.idClient=params['idClient'];
        if( this.idClient)
        this.getAllProduitsClient( this.idClient);
    
  });
}
getAllProduitsClient(idClient: number) {
 this.factureService.findByClientFacture(idClient).subscribe(result=>{
   this.factureDetails=result;
   this.dataSource.data=result;
 })
}
  ngOnInit() {

  }
  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
     }
     clickedMe(){
      this.router.navigateByUrl(`/add-exhibitor/${this.idClient}/5`  )  
  
    }
}
